'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _clinics = require('@vezeeta/enterprise-store/lib/actions/clinics');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ClinicsContainer = function (_Component) {
  _inherits(ClinicsContainer, _Component);

  function ClinicsContainer(props) {
    _classCallCheck(this, ClinicsContainer);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      isUserLoaded: false
    };
    return _this;
  }

  ClinicsContainer.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    var language = nextProps.language,
        clinics = nextProps.clinics,
        user = nextProps.user,
        countries = nextProps.countries,
        isUserLoaded = nextProps.isUserLoaded;

    if (clinics.length === 0 && user && countries.length > 0 && isUserLoaded !== prevState.isUserLoaded && !nextProps.clinicsLoading) {
      nextProps.loadClinics(language);
    }
  };

  ClinicsContainer.prototype.render = function render() {
    return _react2.default.createElement(
      _react.Fragment,
      null,
      this.props.children
    );
  };

  return ClinicsContainer;
}(_react.Component);

ClinicsContainer.propTypes = process.env.NODE_ENV !== "production" ? {
  clinicsLoading: _propTypes2.default.bool.isRequired,
  countries: _propTypes2.default.array.isRequired,
  clinics: _propTypes2.default.array.isRequired,
  user: _propTypes2.default.object,
  loadClinics: _propTypes2.default.func.isRequired,
  children: _propTypes2.default.object.isRequired,
  isUserLoaded: _propTypes2.default.bool.isRequired,
  language: _propTypes2.default.string.isRequired
} : {};

ClinicsContainer.defaultProps = {
  user: undefined
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    clinicsLoading: state.clinics.loading,
    countries: state.country.Countries,
    clinics: state.clinics.Clinics,
    user: state.user.user,
    isUserLoaded: state.user.loaded
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    loadClinics: function loadClinics(language) {
      return dispatch((0, _clinics.loadClinics)(language));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ClinicsContainer);
module.exports = exports['default'];